import {casaTurnedoffFeatures} from 'configs/casa-features'

function isFeatureEnabled(feature) {
  return _.includes(casaTurnedoffFeatures, feature)
}

export {
  isFeatureEnabled
}



// WEBPACK FOOTER //
// ./src/services/feature-check-service.js